import { cloneElement } from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'
import Head from 'next/head'
import { NextPage } from 'next'
import PageHeader from '@components/PageHeader'
import { StepsRenderer } from '@components/Process'
import { Container } from '@components/styled'

const StepsContainer = styled(Container)`
  display: grid;
  grid-gap: 8rem 0;

  ${up('md')} {
    grid-gap: 13.6rem 0;
  }
`

const ProcessPage: NextPage = () => (
  <>
    <Head>
      <title>Process</title>
    </Head>
    <PageHeader
      title={[['Want to', 'know how', 'we get', 'the job', 'done? 🤔']]}
      floatingText="It’s easy as one two three… and four ;)"
    />

    <StepsContainer className="mb-80 mb-md-200">
      {StepsRenderer().map((item, index) =>
        cloneElement(item, {
          reverse: index % 2 !== 0,
          staticPath: true,
        }),
      )}
    </StepsContainer>
  </>
)

export default ProcessPage
